/**
 * Wording for the one place these details are typed: the session a grown-up is
 * preparing. There used to be a second — a lasting description on the learner's
 * card — and it is gone. Kept there it outlived whoever wrote it and was sent to
 * an external AI provider on every personalized session, which is a standing
 * profile of a child rather than a note about today's questions.
 *
 * Whether a session gets personalized is decided on the session itself, so there
 * is no switch: typing something here and pressing the button is the decision.
 */
export const PERSONALIZATION_HINT =
  "Užduočių tekstus AI perrašys apie tai, kas mokiniui artima. Skaičiai, paveikslėliai ir atsakymai nesikeičia — tik istorija aplink klausimą.";

export const PERSONALIZATION_PLACEHOLDER =
  "Pomėgiai, augintiniai, mėgstamos knygos ar žaidimai, sportas — kuo konkrečiau, tuo geriau.";

/**
 * Said where the text is typed, not in a policy page: this goes to an outside
 * company that may train on it, so the one thing not to write is anything that
 * identifies the child.
 */
export const PERSONALIZATION_PRIVACY_HINT =
  "Šis tekstas siunčiamas išoriniam AI teikėjui, kuris gali jį naudoti savo modelių mokymui. Nerašykite vardų, mokyklos, adreso ar kitų duomenų, pagal kuriuos vaiką galima atpažinti — užtenka pomėgių.";

/** Session personalization outcomes, as SessionType#personalizationStatus reports them. */
export type PersonalizationStatus = "OFF" | "READY" | "FAILED";

export function personalizationLabel(
  status: string | null | undefined,
  count: number | null | undefined
): string | null {
  if (status === "READY") {
    return count && count > 0 ? `Pritaikyta mokiniui (${count})` : "Pritaikyta mokiniui";
  }
  if (status === "FAILED") return "Nepavyko pritaikyti — rodomas originalus tekstas";
  return null;
}
